import {
  payPeriodCloseApi,
  payPeriodFinalizeApi, payPeriodOpenApi,
} from './graphql/PayPeriodMutations';

export const SELECT_PAY_PERIOD = 'payroll_processor/SELECT_PAY_PERIOD';

export const selectPayPeriod = (payPeriod) => {
  return {
    type: SELECT_PAY_PERIOD,
    payPeriod,
  };
};

export const lockPayPeriod = (payPeriodId) => {
  return async (dispatch, getState, { client }) => {
    await payPeriodCloseApi(client, payPeriodId);
  };
};

export const finalizePayPeriod = (payPeriodId) => {
  return async (dispatch, getState, { client }) => {
    await payPeriodFinalizeApi(client, payPeriodId);
  };
};

export const reopenPayPeriod = (payPeriodId) => {
  return async (dispatch, getState, { client }) => {
    await payPeriodOpenApi(client, payPeriodId);
  };
};
